import { combineReducers } from 'redux';
import exerciseList from './exercise_list';
import exercise from './exercise';
import cueReducer from './cue_reducer';

export default combineReducers({
    exerciseList,
    exercise,
    cueReducer
});